import PopoverController from "./popover_controller"

export default class extends PopoverController {
  allowHtml = true
  sanitizeContent = false
}
